interface LoadingViewProps {
    size?: number
}

const LoadingView = ({
    size = 100
}: LoadingViewProps) => {
    return (
        <div 
            className="flex justify-center items-center" 
            style={{ height: size }}
        >
            <div 
                className="border-4 border-t-4 border-t-[#704e37] border-gray-200 rounded-full animate-spin"
                style={{ height: size/2, width: size/2 }}
            >

            </div>
        </div>
    )
}

export default LoadingView;